import { render, staticRenderFns } from "./ImageWithText.vue?vue&type=template&id=e7d60c6e&"
import script from "./ImageWithText.vue?vue&type=script&lang=js&"
export * from "./ImageWithText.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports